import { Component, Inject, Prop } from 'vue-property-decorator';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { required, minLength, maxLength, helpers } from 'vuelidate/lib/validators';
import { urlPattern } from '@/shared/formatter/regex-utils';
import {
  CaracteristicaPrograma,
  GradoPrograma,
  InstanciaColegiada,
  ModalidadPrograma,
  OrientacionPrograma,
  ProgramaForm,
  TipoPrograma,
} from '@/entities/snp/administracion/programas/programa.model';
import CatalogosSnp from '@/shared/model/snp/catalogos-snp.factory';
import { Area } from '@/shared/model/enumerations/area';
import ProgramaService from '@/shared/programa/programa.service';
import PersonalBecaService from '@/entities/seguimiento/personal-beca.service';
import { IPersonalBeca, PersonalBeca } from '@/shared/model/seguimiento/personal-beca.model';

const isAfterCreationDate = helpers.withParams(
  { type: 'isAfterCreationDate' },
  (fechaInicio: string, { fechaCreacion }: { fechaCreacion: string }) => {
    return !fechaInicio || !fechaCreacion || new Date(fechaInicio) >= new Date(fechaCreacion);
  }
);

const validations = function () {
  return {
    programa: {
      nombre: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(250),
      },
      maximaInstancia: {
        required,
      },
      modalidad: {
        required,
      },
      grado: {
        required,
      },
      orientacion: {
        required,
      },
      caracteristica: {
        required,
      },
      fechaCreacion: {
        required,
      },
      fechaInicio: {
        required,
        isAfterCreationDate,
      },
      anteDgp: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(200),
      },
      rvoe: {
        maxLength: maxLength(200),
      },
      tipo: {
        required,
      },
      paginaWeb: {
        required,
        urlPattern,
      },
      numeroDeActa: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(100),
      },
      fechaAprobacion: {
        required,
      },
    },
  };
};
@Component({
  validations: validations,
})
export default class ProgramaRegistroF1 extends ApeironComponent {
  @Inject('programaService') private readonly programaService!: () => ProgramaService;
  @Inject('personalBecaService') protected readonly personalBecaService!: () => PersonalBecaService;

  @Prop({ required: true })
  public solucion!: Solucion;

  @Prop({ required: true })
  public solicitud!: Solicitud;

  public programa: ProgramaForm = new ProgramaForm();
  public modalidades: Array<ModalidadPrograma> = CatalogosSnp.obtenerModalidades().filter(modalidad => modalidad.activo);
  public grados: Array<GradoPrograma> = CatalogosSnp.obtenerGrados(Area.POSGRADOS);
  public orientaciones: Array<OrientacionPrograma> = CatalogosSnp.obtenerOrientaciones();
  public caracteristicas: Array<CaracteristicaPrograma> = CatalogosSnp.obtenerCaracteristicas();
  public tipos: Array<TipoPrograma> = CatalogosSnp.obtenerTipos();
  public programaEditado = false;
  public personalBeca: IPersonalBeca = new PersonalBeca();
  public instanciasColegiadas: Array<InstanciaColegiada> = CatalogosSnp.obtenerMaximasInstancia();

  public created(): void {
    this.obtenerPersonalBeca();
  }

  public mounted(): void {
    this.fillProgramaToEdit();
  }

  public save(): void {
    if (!this.$v.$invalid) {
      if (!this.readOnly) {
        this.$emit('submit', { programa: this.programa });
      }
    } else {
      this.alertService().showWarning(this, this.$t('apeironGwApp.pronaceSnp.form.formularioInvalido').toString());
    }
  }

  private fillProgramaToEdit() {
    this.programa = this.solicitud.programa ? ({ ...this.solicitud.programa } as ProgramaForm) : new ProgramaForm();
  }

  public clear() {
    this.programa = new ProgramaForm();
  }

  private obtenerPersonalBeca() {
    this.personalBecaService()
      .find(true, Area.POSGRADOS)
      .then(res => {
        this.personalBeca = res;
      })
      .catch(error => {
        this.alertService().showHttpError(this, error);
      });
  }

  get deshabilitarCampoCaracteristica(): boolean {
    return (this.solicitud.instituciones?.length ?? 0) > 0;
  }
}
